"use client";

import { useEffect } from "react";
import { TokenManager } from "@/lib/api/token-manager";

interface TabTrackerProviderProps {
  children: React.ReactNode;
}

export default function TabTrackerProvider({
  children,
}: TabTrackerProviderProps) {
  useEffect(() => {
    // Initialize or increment client ID for this tab
    const currentClientId = TokenManager.getClientId();
    const newClientId = currentClientId + 1;
    TokenManager.setClientId(newClientId);

    console.log(`🆔 Tab client ID set to: ${newClientId}`);
  }, []);

  return <>{children}</>;
}
